export const CACHE_NAME = 'react-inlinesvg';
export const CACHE_MAX_RETRIES = 10;

export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILED: 'failed',
  READY: 'ready',
  UNSUPPORTED: 'unsupported',
} as const;
